<template>
  <div>
    <Form @submitSuccess="getList" ref="form"/>
    <div class="groupButton">
      <AppButton customType="default" @click="addMenu">新增资源</AppButton>
    </div>
    <BasicTable
      hiddenFooter
      :tableData="tableData"
      :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
      :columns="columns" >
      <template v-slot:operate="{ item }">
        <AppButton type="primary" plain size="small" @click="editMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteMenu(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
      <template v-slot:type="{ item }">
        <el-tag
          :type="item.type === '2' ? '' : item.type === '1' ? 'success' : 'info'"
          effect="dark">
          {{ item.type === '2' ? '菜单' : item.type === '1' ? '视图' : '接口'}}
        </el-tag>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { Navigate } from '../../assets/utils/navigate'
import { PowerService } from '../../service/power.service';
import Form from './formAuthorize';
const columns = [
  { name: '资源名称', key: 'name', style: 'text-align:left' },
  { name: '排序值', key: 'sort' },
  { name: '资源类型', key: 'type', type: 'custom' },
  { name: '操作', key: 'operate', type: 'custom' }
];
  export default {
    name: 'authorize',
    components: { Form },
    data() {
      return {
        fields: [],
        tableData: [],
        columns,
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await PowerService.getPowerList();
        this.tableData = data;
      },
      addMenu() {
        this.$refs.form.open('add');
      },
      async editMenu(data) {
        const editData = await PowerService.getPowerList(data.id);
        this.$refs.form.open('edit', editData);
      },
      deleteMenu(data) {
        MessageBox.confirm('确定要删除这条资源吗？', '删除资源').then(async () => {
          await PowerService.deleteResource(data.id);
          this.getList();
          this.$$refs.form.update();
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1vw;
}
</style>